<template>
  <div class="modal auto_adjust popup publicSignIn">
    <div class="modal--backdrop" @click="dismiss(false)"></div>
    <div class="modal--content min--width--30">
      <div v-if="showPublicSignInForm" class="modal--header">
        <IconComponent
          @click="dismiss(false)"
          class="newHeadericon"
          icon="close-times.svg"
        />
      </div>
      <!-- <div v-if="!showPublicSignInForm" class="model--cover">
            <div class="profileListingCardHeadDv">
                <figure>
                    <img :src="images.coverPhoto" @error="handleCoverPhotoError" crossorigin="anonymous" />
                </figure>
                <IconComponent
                    @click="dismiss(false)"
                    class="newHeadericon"
                    icon="close-times.svg"
                />
            </div>
            <div class="avatar-container">
                <ProfileAvatarComponent
                     class="semilarge"
                     v-if="images.profilePicture" :key="images.profilePicture"
                    :profileImage="images.profilePicture"
                    :badges="false"
                    :camera="false"
                    :redirectProfile="false"
                />
            </div> 
        </div> -->
      <div class="modal--body signInContainer">
        <!-- <template v-if="!showPublicSignInForm">
                <div class="uerStatsContainer">
                 <div>
                     <p class="userName">{{ userData?.fullName  }}</p>
                     <p class="userHanlde">{{ userData?.userName  }}</p>
                 </div>
                 <div class="userFollowersContainer">
                     <div>
                         <p class="userFollowersStats">{{ userData?.followersCount  }}</p>
                         <p class="userFollowers">Followers</p>
                     </div>
                     <div class="border"></div>
                     <div>
                         <p class="userFollowersStats">{{ userData?.viewsCount  }}</p>
                         <p class="userFollowers">Assets</p>
                     </div>
                 </div>
                </div>
                <p class="userBio">{{ userData?.bio }}</p>
                 <div v-if="hasStocks" class="publicStockGridDv" >
               <template v-for="item in displayedStocks" :key="item.stockId">
                 <el-tooltip class="box-item" effect="dark" :content="item.symbol?.toUpperCase()" placement="top-start">
                   <StockImageTag class="stocktag" :stockId="item.stockId" :imgUrl="item.logoUrl" :symbol="item.symbol"
                     :market="item?.type?.toLowerCase()" />
                 </el-tooltip>
               </template>
               <p class="stocksLength noStockContainer" v-if="hasAdditionalStocks && additionalStocksCount > 0">
                 +{{ additionalStocksCount }}
               </p>
                 </div>
                 <div  class="profileListingCardfooterDv" >
                    <InvestmentBarComponent :hiddenInfo="true" :showPercent="false" :stocks="favoriteInvestmentsStocks" :fromSideMenu="true" v-if="
                favoriteInvestmentsStocks && favoriteInvestmentsStocks.length
              " />
                 </div>
                 <p class="text-title">Join to View {{ firstName }}'s Full Profile</p>
            </template> -->
        <IconComponent
          v-if="!showPublicSignInForm"
          @click="dismiss(false)"
          class="newHeadericon"
          icon="close-times.svg"
        />
        <div v-if="!showPublicSignInForm" class="avatar-container">
          <ProfileAvatarComponent
            class="semilarge"
            v-if="images.profilePicture"
            :key="images.profilePicture"
            :profileImage="images.profilePicture"
            :badges="false"
            :camera="false"
            :redirectProfile="false"
          />
          <div>
            <p class="userName">{{ userData?.fullName }}</p>
            <p class="userHanlde">@{{ userData?.userName }}</p>
          </div>
          <p class="text-title">Join to View {{ firstName }}'s Full Profile</p>
        </div>
        <SignInComponent
          :openExistingUser="true"
          :isPublicSignIn="!fromHeader ? true : false"
          :onShowForm="toggleSignInForm"
          :fromPostDetail="fromPostDetail"
          :postData="postData"
          :fromCrox="fromCrox"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { popModal, Modal } from "jenesius-vue-modal";
import { defineComponent, ref, computed, onMounted } from "vue";
import IconComponent from "@/components/IconComponent.vue";
import ProfileAvatarComponent from "@/components/ProfileAvatarComponent.vue";
import SignInComponent from "@/views/public/Signin.vue";
import User from "@/helpers/models/user.model";
import utilService from "@/services/util.service";
import { loadImageWithTracking } from "@/helpers/image.helpers";
import StockImageTag from "@/components/StockImageTag.vue";
import InvestmentBarComponent from "@/views/private/profile-screen/components/investment-bar/InvestmentBarComponent.vue";

export default defineComponent({
  props: {
    postId: {
      type: String,
      default: null,
    },
    userData: {
      type: Object,
      required: false,
      default: () => ({
        _id: "",
        fullName: "",
        userName: "",
        bio: "",
        followersCount: 0,
        viewsCount: 0,
        profilePicture: "",
        coverPhoto: "",
        sections: [],
      }),
    },
    fromHeader: {
      type: Boolean,
      default: false,
    },
    fromPostDetail: {
      type: Boolean,
      default: false,
    },
    postData: {
      type: Object,
    },
    fromCrox: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IconComponent,
    ProfileAvatarComponent,
    SignInComponent,
    StockImageTag,
    InvestmentBarComponent,
  },
  emits: [Modal.EVENT_PROMPT],
  setup(props, { emit }) {
    const profileImage = ref<string>("");
    const profileUser = ref<User>(new User());
    // Initialize showPublicSignInForm based on fromHeader prop
    const showPublicSignInForm = ref<boolean>(props.fromHeader);
    const stocksRow = ref<HTMLElement | null>(null);
    const dismiss = async (val: boolean) => {
      popModal();
    };
    const images = ref({
      profilePicture: "",
      coverPhoto: "",
    });

    const loadProfileImages = () => {
      if (!props.userData._id) return;
      const profilePicCount = parseInt(props.userData.profilePicture) || 0;
      const coverPhotoCount = parseInt(props.userData.coverPhoto) || 0;
      images.value = {
        profilePicture: utilService.getUserProfilePicture(
          props.userData._id,
          profilePicCount,
          "male",
          false,
          false
        ),
        coverPhoto: utilService.getUserProfilePicture(
          props.userData._id,
          coverPhotoCount,
          "male",
          true,
          false
        ),
      };
    };

    const handleCoverPhotoError = (event: Event) => {
      const target = event.target as HTMLImageElement;
      target.src = utilService.coverImageError();
    };

    const favoriteInvestmentsStocks = computed(() => {
      if (!props.userData?.sections) return [];
      const favoriteSection = props.userData.sections.find((section: any) => {
        return section?.type === "favouriteInvestment";
      });
      return favoriteSection?.data?.stocks || [];
    });

    const hasStocks = computed(
      () => favoriteInvestmentsStocks.value.length > 0
    );

    const displayedStocks = computed(
      () => favoriteInvestmentsStocks.value.slice(0, 7) || []
    );

    const additionalStocksCount = computed(
      () => favoriteInvestmentsStocks.value.length - 7
    );

    const hasAdditionalStocks = computed(
      () => favoriteInvestmentsStocks.value.length > 3
    );

    const stockStatsData = computed(() => {
      console.log(
        "favoriteInvestmentsStocks.value",
        favoriteInvestmentsStocks.value
      );
      return utilService.getStocksBar(favoriteInvestmentsStocks.value, 100, 6);
    });

    const toggleSignInForm = () => {
      showPublicSignInForm.value = !showPublicSignInForm.value;
    };

    const firstName = computed(() => {
      if (!props.userData?.fullName) return "User";
      const nameParts = props.userData.fullName.trim().split(" ");
      return nameParts[0] || "User";
    });

    onMounted(() => {
      loadProfileImages();
    });

    return {
      dismiss,
      profileImage,
      profileUser,
      showPublicSignInForm,
      toggleSignInForm,
      hasStocks,
      displayedStocks,
      stockStatsData,
      hasAdditionalStocks,
      additionalStocksCount,
      images,
      handleCoverPhotoError,
      firstName,
      favoriteInvestmentsStocks,
    };
  },
});
</script>
<style lang="scss">
.publicSignIn {
  .modal--content {
    width: 490px;
    background: var(--base-regular) 0 0 no-repeat padding-box;
    box-shadow: 0 11px 43px rgba(0, 0, 0, 0.4);
    border-radius: 20px;
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-flow: column;
    max-height: max-content;
    height: auto;
    border: 10px solid transparent;
    background: linear-gradient(var(--base-regular), var(--base-regular))
        padding-box,
      linear-gradient(45deg, rgba(255, 0, 119, 0.6), #332963) border-box;
  }
  .model--cover {
    position: relative;
    margin-bottom: 45px;
    .profileListingCardHeadDv {
      figure {
        height: 80px;
        img {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }
    }
    .newHeadericon {
      position: absolute;
      top: 10px;
      right: 10px;
      color: var(--base-text-white);
      background: var(--base-light);
      border-radius: 4px;
      padding: 4px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
  .modal--header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px 20px 0 0;
    .newHeadericon {
      color: var(--base-text-white);
      background: var(--base-light);
      border-radius: 4px;
      padding: 4px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
  .publicStockGridDv {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    .noStockContainer {
      min-height: 40px;
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--base-lightest);
      color: var(--base-text) !important;
      padding: 10px;
      border-radius: 8px;
      font-size: var(--font-xs);
      font-weight: 500;
      border: 2px solid var(--base-text);
      @media only screen and (min-width: 1280px) and (max-width: 1700px) {
        min-height: 32px;
        height: 32px;
        width: 32px;
        padding: 8px;
        font-size: var(--font-2xs);
      }
    }
  }
  .profileListingCardHeadDv {
  }
  .modal--body {
    flex-grow: 1;
    overflow: hidden auto;
    padding: 0 30px;
    .newHeadericon {
      position: absolute;
      top: 10px;
      right: 10px;
      color: var(--base-text-white);
      background: var(--base-light);
      border-radius: 4px;
      padding: 4px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .avatar-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      text-align: center;
      margin-top: 30px;
      .userName {
        font-size: var(--font-2lg);
        font-weight: 600;
        color: var(--base-text-white);
      }
      .userHanlde {
        font-size: var(--font-2sm);
        color: var(--base-text);
      }
      .text-title {
        font-size: 20px;
        font-weight: 600;
        color: var(--base-text-white);
        margin-top: 8px;
        margin-bottom: 0px;
      }
    }
  }

  .text-title {
    font-size: 20px;
    font-weight: 600;
    color: var(--base-text-white);
    margin-top: 20px;
    margin-bottom: 0px;
  }
  .signInContainer {
    .uerStatsContainer {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 20px;
      margin-top: 10px;
      .userName {
        font-size: var(--font-2lg);
        font-weight: 600;
        color: var(--base-text-white);
      }
      .userHanlde {
        font-size: var(--font-2sm);
        color: var(--base-text);
      }
      .userFollowersContainer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 20px;
        .border {
          height: 30px;
          border-color: var(--base-lightest) !important;
        }
        .userFollowersStats {
          font-size: var(--font-2sm);
          font-weight: 600;
          color: var(--base-text-white);
        }
        .userFollowers {
          font-size: var(--font-xs);
          color: var(--base-text);
        }
      }
    }
    .userBio {
      font-size: var(--font-2sm);
      color: var(--base-text-white);
      opacity: 60%;
      margin-bottom: 20px;
    }
    .mainAuthDv {
      background: transparent;
      height: 100%;
      .newUserLink {
        margin-bottom: -10px;
        background: var(--base-light);
        border-radius: 10px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        font-size: var(--font-2sm);
        margin-top: 20px;
        .joinLink {
          color: var(--section-heading-color);
          text-decoration: underline;
          cursor: pointer;
        }
        .new-header-log.svg_icon {
            width: 130px;
        //   svg {
        //   }
        }
      }
      .auth--form-body .icons__wrapper {
        margin: 35px 0 5px 0 !important;
      }
      .auth--form-body {
        padding: 0 !important;
      }
      .auth {
        .auth-form-UI {
          padding: 20px 0 !important;
        }
      }
      .auth-td {
        display: none !important;
      }
      .auth_wrapper {
        background: transparent;
        height: auto;
        max-height: fit-content !important;
        width: 100% !important;
        .publicSignInBtnRow {
          .btn {
            height: 50px !important;
            font-size: var(--font-2sm);
            font-weight: 600;
          }
        }
        .btn_row {
          .btn {
            height: 50px !important;
            font-size: var(--font-2sm);
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
